export default __webpack_public_path__ + "static/media/Youth_Illustrations-ubc.41261f1e.png";